/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { Link as RouterLink } from "react-router-dom";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React base styles
import typography from "assets/theme/base/typography";
import Feedback from "layouts/pages/feedback";

function Footer({
  company = { href: "https://www.creative-tim.com/", name: "Creative Tim" },
  links = [
    { href: "https://www.creative-tim.com/", name: "Creative Tim" },
    { href: "https://www.updivision.com/", name: "UPDIVISION" },
    { href: "https://www.creative-tim.com/presentation", name: "About Us" },
    { href: "https://www.creative-tim.com/blog", name: "Blog" },
    { href: "https://www.creative-tim.com/license", name: "License" },
  ],
  position = "",
}) {
  return (
    <MDBox
      mt={3}
      display="flex"
      style={{
        // Footer styles
        position: position,
        width: "100%",
        padding: "1rem",
        borderRadius: "0.5rem",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
        background: "white",
        zIndex: 98,
        bottom: 0,
      }}
    >
      <MDTypography
        variant="button"
        fontWeight="regular"
        color="text"
        mr="auto"
      >
        <Link
          component={RouterLink}
          to="/feedback"
          color="info"
          fontWeight="bold"
        >
          Feedback
        </Link>
      </MDTypography>
      <MDTypography variant="body2" fontWeight="regular" color="text" ml={3}>
        &copy; {new Date().getFullYear()}, Powered by{" "}
        <Link
          href="https://www.quantuniversity.com/"
          target="_blank"
          fontWeight="bold"
          color="info"
          style={{
            textDecoration: "underline",
          }}
        >
          QuantUniversity
        </Link>
        . All rights reserved.
      </MDTypography>
    </MDBox>
  );
}

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
